@use '@/styles/tokens' as *;

.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 21px;
  row-gap: var(--space-6);
  margin-bottom: var(--space-6);
}

.empty {
  color: $color-neutral-600;
}
